"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRandomString = void 0;
var numbers_1 = require("../numbers");
var getRandomChar_1 = require("./getRandomChar");
var getRandomString = function (min, max) {
    if (min === void 0) { min = 1; }
    if (max === void 0) { max = 10; }
    return new Array((0, numbers_1.getRandomInt)(max, min))
        .join(',')
        .split(',')
        .map(getRandomChar_1.getRandomChar)
        .join('');
};
exports.getRandomString = getRandomString;
//# sourceMappingURL=getRandomString.js.map